import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: "AIzaSyCG2aN1Rt2i_tabzmbZe5_L3SrVeA7yncw",
  authDomain: "centro-rio.firebaseapp.com",
  projectId: "centro-rio",
  storageBucket: "centro-rio.appspot.com",
  messagingSenderId: "608516132121",
  appId: "1:608516132121:web:63eeea4ea43018c263c988"
};
// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);
export const analytics = getAnalytics(firebaseApp);
export const database = getDatabase(firebaseApp);
